var _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAuthlogo = function SvgAuthlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 96,
    viewBox: "0 0 87 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 85,
    height: 85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 42.5C86 65.9721 66.9721 85 43.5 85C20.0279 85 1 65.9721 1 42.5C1 19.0279 20.0279 0 43.5 0C66.9721 0 86 19.0279 86 42.5Z",
    fill: "#2862AC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5 46.2868C67.757 46.2868 72.3329 41.8576 72.3329 36C72.3329 30.1424 67.757 25.7132 62.5 25.7132C57.243 25.7132 52.6671 30.1424 52.6671 36C52.6671 41.8576 57.243 46.2868 62.5 46.2868ZM62.5 55C72.7173 55 81 46.4934 81 36C81 25.5066 72.7173 17 62.5 17C52.2827 17 44 25.5066 44 36C44 46.4934 52.2827 55 62.5 55Z",
    fill: "#E77CCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 46.2868C28.757 46.2868 33.3329 41.8576 33.3329 36C33.3329 30.1424 28.757 25.7132 23.5 25.7132C18.243 25.7132 13.6671 30.1424 13.6671 36C13.6671 41.8576 18.243 46.2868 23.5 46.2868ZM23.5 55C33.7173 55 42 46.4934 42 36C42 25.5066 33.7173 17 23.5 17C13.2827 17 5 25.5066 5 36C5 46.4934 13.2827 55 23.5 55Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1855 57.8782C49.2506 57.8782 37.7275 64.8201 32.7574 74.0975L25 69.8816C31.7425 57.2956 46.5348 49 63.1855 49C80.3623 49 95.5878 57.837 102 71.1172L94.073 75C89.3791 65.2785 77.5818 57.8782 63.1855 57.8782Z",
    fill: "#E77CCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6896 57.8782C10.9356 57.8782 -0.437819 64.8201 -5.3433 74.0975L-13 69.8816C-6.34508 57.2956 8.25511 49 24.6896 49C41.6433 49 56.6711 57.837 63 71.1172L55.176 75C50.543 65.2785 38.8989 57.8782 24.6896 57.8782Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 36C61 46.4934 52.4934 55 42 55C31.5066 55 23 46.4934 23 36C23 25.5066 31.5066 17 42 17C52.4934 17 61 25.5066 61 36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 46.2868C47.3991 46.2868 52.0987 41.8576 52.0987 36C52.0987 30.1424 47.3991 25.7132 42 25.7132C36.6009 25.7132 31.9013 30.1424 31.9013 36C31.9013 41.8576 36.6009 46.2868 42 46.2868ZM42 55C52.4934 55 61 46.4934 61 36C61 25.5066 52.4934 17 42 17C31.5066 17 23 25.5066 23 36C23 46.4934 31.5066 55 42 55Z",
    fill: "#BB6BD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8809 54C24.3981 54 6.80753 66.6486 1 77.3634L42.8809 110L84 77.3634C78.4931 66.0907 61.3636 54 42.8809 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1429 75.7749L42.8311 98.9101L72.1637 75.6286C69.9974 73.31 67.1652 70.9596 63.7466 68.8788C57.59 65.1315 50.245 62.7021 42.8809 62.7021C35.5893 62.7021 28.1258 65.2254 21.7299 69.0984C18.2961 71.1777 15.4012 73.5041 13.1429 75.7749ZM84 77.3634L42.8809 110L1 77.3634C6.80753 66.6486 24.3981 54 42.8809 54C61.3636 54 78.4931 66.0907 84 77.3634Z",
    fill: "#BB6BD9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuthlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/authlogo.8bc0249b.svg";
export { ForwardRef as ReactComponent };